import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COURSES_FEATURE_KEY, State } from './courses.reducer';

export const getCoursesState = createFeatureSelector<State>(COURSES_FEATURE_KEY);

export const getCoursesLoaded = createSelector(getCoursesState, (state: State) => state.courses);
export const getStepBlocksLoaded = (courseId: string) => createSelector(getCoursesState, (state: State) => state.blocks[courseId]);
export const getStepsLoaded = createSelector(getCoursesState, (state: State) => state.stepsCategory);

export const getLoaded = createSelector(getCoursesState, (state: State) => state.loaded);
